import { create } from 'zustand';
import { modelValues } from './utils/model-values';

const useModelStore = create((set) => ({
    modelData: { ...modelValues },
  setModelData: (newFormData) => 
    set((state) => ({
      modelData: { ...state.previewData, ...newFormData },
    })),
  resetModel: () =>
    set(() => ({
      modelData: JSON.parse(JSON.stringify(modelValues)),
    })),
}));

export default useModelStore;
